import React from "react"
import PropTypes from "prop-types"
//import { Link } from 'gatsby'
import Link from "../Link"
import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
import Button from "./Button"

const useStyles = makeStyles((theme) => ({
  viewAllButton: {
    marginTop: theme.spacing(7),
  },
}))

const ViewAllButton = ({ destination }) => {
  const classes = useStyles()
  return (
    <div className={classes.viewAllButton}>
      <Grid container spacing={2} justify="center">
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to={destination}
          >
            View All
          </Button>
        </Grid>
      </Grid>
    </div>
  )
}

ViewAllButton.propTypes = {
  destination: PropTypes.string.isRequired,
}

export default ViewAllButton
